import * as yup from 'yup'
import { useNuxtApp } from '#app'

const forbiddenExtensions = ['exe', 'bat', 'sh', 'cmd', 'msi', 'html', 'js', 'py', 'php']

// mode - img или по дефолту all
export function createFileUploaderSchema(mode = 'all') {
  return yup.object({
    files: yup
      .array()
      .nullable()
      .transform((value, originalValue) => {
        // если пришёл объект, превращаем в массив
        if (!value) return []
        return Array.isArray(value) ? value : [value]
      })
      .test('fileSize', '', function(value) {
        const { t } = useNuxtApp().$i18n || useNuxtApp().vueApp.config.globalProperties
        const files = value ? (Array.isArray(value) ? value : [value]) : []

        if (!files.length) {
          return true
        }

        const invalidFiles = files.filter(file => file.size > 5 * 1024 * 1024)

        if (invalidFiles.length === 1) {
          return this.createError({
            message: t('forms.errors.tooBigFileWithName', { name: invalidFiles[0].name }),
          })
        }

        if (invalidFiles.length > 1) {
          return this.createError({
            message: t('forms.errors.tooBigFilesMultiple'),
          })
        }

        return true
      })
      .test('fileType', '', function(value) {
        const { t } = useNuxtApp().$i18n || useNuxtApp().vueApp.config.globalProperties
        const files = value ? (Array.isArray(value) ? value : [value]) : []

        if (!files.length) {
          return true
        }

        let invalidFiles = []

        if (mode === 'img') {
          invalidFiles = files.filter(
            file => !['image/jpeg', 'image/png', 'image/webp'].includes(file.type),
          )
        } else if (mode === 'all') {
          invalidFiles = files.filter(
            file => forbiddenExtensions.includes(file.name.split('.').pop().toLowerCase()),
          )
        }

        if (invalidFiles.length === 1) {
          return this.createError({
            message: t('forms.errors.invalidFileTypeWithName', { name: invalidFiles[0].name }),
          })
        }

        if (invalidFiles.length > 1) {
          return this.createError({
            message: t('forms.errors.invalidFilesMultiple'),
          })
        }

        return true
      }),
  })
}
